import { rankingData } from '@/mocks/home';

const rankColors: Record<number, string> = {
  1: 'bg-accent-500 text-background-50',
  2: 'bg-primary-500 text-background-950',
  3: 'bg-secondary-500 text-background-950',
};

export default function SectionRanking() {
  return (
    <section
      id="ranking"
      className="py-16 md:py-20 bg-background-100"
    >
      <div className="max-w-[1920px] mx-auto px-4 md:px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-8 md:mb-10 gap-3">
          <div>
            <span className="inline-block text-xs font-medium text-primary-500 bg-primary-500/10 px-3 py-1 rounded-full mb-3">
              热度榜单
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">
              热播排行
            </h2>
            <p className="text-sm text-foreground-400 mt-2">实时热度排名，大家都在看</p>
          </div>
          <span className="text-[11px] text-foreground-500">数据每小时更新</span>
        </div>

        <div className="max-w-2xl mx-auto space-y-2">
          {rankingData.map((item) => {
            const rankStyle = rankColors[item.rank] || 'bg-background-300/60 text-foreground-400';

            return (
              <div
                key={item.rank}
                className="flex items-center gap-4 bg-background-200/70 rounded-xl border border-background-300/40 p-4 hover:border-background-400/60 transition-all cursor-pointer group"
              >
                {/* Rank number */}
                <div className={`w-9 h-9 rounded-lg flex items-center justify-center font-heading font-bold text-sm shrink-0 ${rankStyle}`}>
                  {item.rank <= 3 ? (
                    <span>{item.rank}</span>
                  ) : (
                    <span>{item.rank}</span>
                  )}
                </div>

                {/* Info */}
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-100 truncate group-hover:text-primary-400 transition-colors">
                    {item.title}
                  </h3>
                  <span className="text-[11px] text-foreground-500">{item.category}</span>
                </div>

                {/* Heat */}
                <div className="text-right shrink-0">
                  <div className="flex items-center gap-1 text-accent-400">
                    <i className="ri-fire-line text-sm"></i>
                    <span className="text-sm font-semibold font-heading">{item.heat}</span>
                  </div>
                  <div className="text-[10px] text-foreground-500">热度值</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}